/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_BalanceInputs */

const en_confirm_balance = /** @type {(inputs: Confirm_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const he_confirm_balance = /** @type {(inputs: Confirm_BalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יתרה`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Confirm_BalanceInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_balance = /** @type {((inputs?: Confirm_BalanceInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_BalanceInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_balance(inputs)
	return he_confirm_balance(inputs)
});